import React from "react";
import SearchField from "./SearchField";
import { processEnvServer } from "@RHCommerceDev/hooks/useSsrHooks";
import { Theme, useMediaQuery } from "@mui/material";
import { getReqContext } from "@RHCommerceDev/utils/reqContext";
import { getSelectorsByUserAgent } from "react-device-detect";
import SearchDrawer from "./SearchDrawer";

const SearchWrapper = () => {
  // On SSR, detect if device is mobile from user-agent and set `mobile` flag.
  const req = getReqContext();
  let mobile = false;
  const userAgentSSR = req && req?.headers["user-agent"];
  if (userAgentSSR) {
    const { isMobile } = getSelectorsByUserAgent(userAgentSSR);
    mobile = !!isMobile;
  }

  //On CSR, Check if viewport is ≥ "md"
  const smUp = useMediaQuery<Theme>(theme => theme.breakpoints.up("sm"), {
    noSsr: !processEnvServer
  });

  const isMobile = processEnvServer ? mobile : !smUp;

  return isMobile ? <SearchDrawer /> : <SearchField />;
};

export default SearchWrapper;
